export default "__VITE_ASSET__DxUZuLh___"